import script from "./UHI.vue?vue&type=script&setup=true&lang=js"
export * from "./UHI.vue?vue&type=script&setup=true&lang=js"

import "./UHI.vue?vue&type=style&index=0&id=eae766b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eae766b8"]])

export default __exports__